// assets/questions-share.js
(function () {
  function initQsBlocks() {
    var blocks = document.querySelectorAll('.qs-section[data-qs-block]');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var openBtn  = block.querySelector('[data-qs-open]');
      var dialog   = block.querySelector('[data-qs-dialog]');
      var closeBtn = dialog ? dialog.querySelector('[data-qs-close]') : null;
      var copyBtn  = block.querySelector('[data-qs-share]');

      if (!openBtn || !dialog) return;

      function getProductForm() {
        var outer = block.closest('.product--outer') || document;
        return (
          outer.querySelector('form[action*="/cart/add"]') ||
          outer.querySelector('form[data-product-form]') ||
          document.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('form[data-product-form]')
        );
      }

      function getCurrentVariant(form) {
        if (!form) return null;

        var idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return null;

        var currentId = String(idInput.value);
        var variants =
          (window.meta && meta.product && meta.product.variants) || [];

        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === currentId) {
            return variants[i];
          }
        }
        return null;
      }

      function syncVariantContext() {
        var form    = getProductForm();
        var variant = getCurrentVariant(form);

        var variantLabel = dialog.querySelector('[data-qs-variant-label]');
        var variantField = dialog.querySelector('[data-qs-field="variant"]');
        var skuField     = dialog.querySelector('[data-qs-field="sku"]');

        if (variant && variantLabel) {
          variantLabel.textContent = variant.title || '';
        }

        if (variant && variantField) {
          variantField.value = variant.title || '';
        }

        if (skuField) {
          if (variant && variant.sku) {
            skuField.value = variant.sku;
          } else {
            var skuDisplay = document.querySelector('[data-awm-sku-value]');
            skuField.value = skuDisplay ? skuDisplay.textContent.trim() : '';
          }
        }
      }

      function openDialog(e) {
        e.preventDefault();
        syncVariantContext();

        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', 'open'); // Fallback
        }
      }

      function closeDialog(e) {
        if (e) e.preventDefault();
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      }

      // Öffnen
      openBtn.addEventListener('click', openDialog);

      // Schließen-Button
      if (closeBtn) {
        closeBtn.addEventListener('click', closeDialog);
      }

      // Klick auf Hintergrund schließt
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) {
          closeDialog(e);
        }
      });

      // Escape (für Fallback)
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeDialog(e);
        }
      });

      // Variantenwechsel vom Theme
      document.addEventListener('variant:change', function () {
        syncVariantContext();
      });

      // Link kopieren
      if (copyBtn) {
        copyBtn.addEventListener('click', function (e) {
          e.preventDefault();

          var url = window.location.href;
          var originalText = copyBtn.textContent;

          function showFeedback(text) {
            copyBtn.textContent = text;
            setTimeout(function () {
              copyBtn.textContent = originalText;
            }, 2000);
          }

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard
              .writeText(url)
              .then(function () {
                showFeedback('Link kopiert');
              })
              .catch(function () {
                showFeedback('Konnte nicht kopieren');
              });
          } else {
            var tmp = document.createElement('input');
            tmp.value = url;
            document.body.appendChild(tmp);
            tmp.select();
            try {
              document.execCommand('copy');
              showFeedback('Link kopiert');
            } catch (err) {
              showFeedback('Konnte nicht kopieren');
            }
            document.body.removeChild(tmp);
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQsBlocks);
  } else {
    initQsBlocks();
  }
})();